/** Maps API row (camelCase or PascalCase) to waitlist grid DTO. */
export function mapFamilyFestWaitlistRow(raw) {
    const r = raw;
    return {
        id: String(r.id ?? r.Id ?? ''),
        invitationId: String(r.invitationId ?? r.InvitationId ?? ''),
        vdkEventId: String(r.vdkEventId ?? r.VDKEventId ?? ''),
        firstName: String(r.firstName ?? r.FirstName ?? ''),
        middleName: (r.middleName ?? r.MiddleName),
        lastName: String(r.lastName ?? r.LastName ?? ''),
        email: String(r.email ?? r.Email ?? ''),
        companyName: (r.companyName ?? r.CompanyName),
        expectedNoOfPersons: (r.expectedNoOfPersons ?? r.ExpectedNoOfPersons),
        adultCount: (r.adultCount ?? r.AdultCount),
        kidsCount: (r.kidsCount ?? r.KidsCount),
        travelMode: (r.travelMode ?? r.TravelMode),
        waitingListSortOrder: (r.waitingListSortOrder ?? r.WaitingListSortOrder),
        queueNumber: (r.queueNumber ?? r.QueueNumber),
        status: (r.status ?? r.Status),
        isRegistrationComplete: (r.isRegistrationComplete ?? r.IsRegistrationComplete),
        isWaitingLinkSent: (r.isWaitingLinkSent ?? r.IsWaitingLinkSent),
        waitingLinkSentTime: (r.waitingLinkSentTime ?? r.WaitingLinkSentTime),
        isWaitingLinkExpired: (r.isWaitingLinkExpired ?? r.IsWaitingLinkExpired),
        waitingLinkExpiredTime: (r.waitingLinkExpiredTime ?? r.WaitingLinkExpiredTime),
        createdDate: String(r.createdDate ?? r.CreatedDate ?? ''),
        lastModifiedDate: (r.lastModifiedDate ?? r.LastModifiedDate)
    };
}
